import React from "react";

function WalletSymbols({ sx, action, symbol, customClass = null }) {
  return (
    <span
      className={`material-symbols-outlined ${customClass}`}
      style={sx}
      onClick={action || null}
    >
      {symbol}
    </span>
  );
}

export default WalletSymbols;
